import { Outlet } from "react-router-dom";

const Organization = () => {

  return <Outlet />
}

export default Organization;